import { useT } from '../../i18n'
/**
 * "How stamp time works" explainer, opened from the ? next to the
 * subscription line whenever stamps are involved.
 *
 * The billing facts here are the verified ones: stamp time is banked
 * AFTER paid time (admin_upsert_email_subscription re-stacks unused
 * grants on every store renewal, so they are never eaten and never
 * double counted), and the app cannot stop a store subscription from
 * renewing — Apple and Stripe keep charging until the USER cancels.
 * That is why the copy tells subscribers to cancel if they want their
 * stamp time to start being used.
 */
export function StampsInfoOverlay({ onDismiss }: { onDismiss: () => void }) {
  const t = useT()
  const points: Array<{ title: string; body: string }> = [
    {
      title: t('Earning and trading'),
      body: 'Stamps are earned on jordandraper.com: every $50 in purchases earns one, with bonus stamps for things like joining the newsletter. Trade them for All-Access time on your website account page: 3 stamps for a month, 20 for a year. Trading happens on the website only.',
    },
    {
      title: t('Free time, all features'),
      body: t('Stamps give you free subscription time that covers every All-Access feature of the app. It is not a paid subscription: it never charges you anything, and when it expires it cannot trigger any renewal or payment.'),
    },
    {
      title: t('Also subscribed through Apple or Stripe?'),
      body: 'A paid subscription keeps renewing, and charging, until you cancel it with the store you subscribed through. The app cannot stop those charges. While your subscription is active, your stamp time stays queued and unused. If you want to use it, cancel your subscription (for Apple: Settings, then Subscriptions) and your stamp time takes over once the paid time runs out. Queued time is never lost and never double counted.',
    },
    {
      title: t('Using Hide My Email?'),
      body: t('If you signed in with Apple and hid your email, your web stamps live under your real email address. Link your addresses on the website account page and your traded time will show up here.'),
    },
  ]

  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-6"
         role="dialog" aria-modal="true" aria-label={t('How stamp time works')}>
      <div className="w-full max-w-sm rounded-3xl border-2 border-brand-border bg-white
                      shadow-card p-6 max-h-[80vh] overflow-y-auto">
        <p className="text-[10px] font-semibold text-brand-gold uppercase tracking-widest">{t('How it works')}</p>
        <h2 className="font-display text-xl font-bold text-brand-text mb-4">{t('App time from stamps')}</h2>

        <div className="space-y-4 mb-5">
          {points.map(p => (
            <div key={p.title}>
              <p className="text-sm font-semibold text-brand-text">{p.title}</p>
              <p className="text-sm text-brand-muted leading-snug mt-0.5">{p.body}</p>
            </div>
          ))}
        </div>

        <button onClick={onDismiss} className="btn-primary">{t('Got it')}</button>
      </div>
    </div>
  )
}
